import actionTypes from "../actionTypes";

const roles = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ROLES_FETCH:
      return action.payload.data;
    case actionTypes.ROLE_FETCH:
      if (state.filter(role => action.payload.data.id === role.id).length) {
        return state.map(role => {
          if (role.id === action.payload.data.id) {
            return action.payload.data;
          }
          return role;
        });
      }

      return [...state, action.payload.data];
    case actionTypes.PERMISSION_PUT_TO_ROLE:
      return state.map(role => {
        if (role.id === action.payload.role.id) {
          return Object.assign({}, role, {
            permissions: [...role.permissions, action.payload.permission]
          });
        }
        return role;
      });
    case actionTypes.PERMISSION_DELETE_FROM_ROLE:
      return state.map(role => {
        if (role.id === action.payload.role.id) {
          return Object.assign({}, role, {
            permissions: role.permissions.filter(permission => {
              return action.payload.permission.id !== permission.id;
            })
          });
        }
        return role;
      });
    default:
      return state;
  }
};

export default roles;



// WEBPACK FOOTER //
// ./src/redux/reducers/Roles.js